// HTML escaping for safe interpolation into innerHTML strings.
//
// This is the single guard between user-controlled data (terminal names,
// group names, log events) and innerHTML assignments. Anything that
// gets injected as raw HTML MUST run through this first.
//
// Lifted from admin/index.php's original `function escapeHtml(s)`. The
// only change is the explicit return-type and `unknown` input — the
// original accepted `s` untyped, which TypeScript would otherwise reject.

export function escapeHtml(s: unknown): string {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c] ?? c));
}